module.exports = {
	acl(user, defineAbility) {
		const ability = defineAbility((can, cannot) => {
			if (user.role === 'admin') {
				can('manage', 'Currency');
			} else {
				cannot('manage', 'Currency');
				can('read', 'Currency');
			}
		});

		return { ability };
	}
};
